import React from 'react';

import { IconProps } from './types';

export const CellPlusIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="26"
        viewBox="0 0 26 26"
        width="26"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <circle cx="13" cy="13" r="9" stroke={color} strokeWidth="1.75" />
        <path
          d="M8.125 13H17.875"
          stroke={color}
          strokeLinecap="round"
          strokeWidth="1.75"
        />
        <path
          d="M13 8.125L13 17.875"
          stroke={color}
          strokeLinecap="round"
          strokeWidth="1.75"
        />
      </svg>
    );
  },
);
